import { useState, useEffect, useRef } from "react";
import { database, ref, onValue, off } from "../../config/firebase";
import { getTenantId } from "../utils/helpers/tenantConfig";

const DEFAULTS = {
  state: null,
  percentage: 0,
  message: "",
  isCompleted: false,
  isFailed: false,
  isListening: false,
};

const useSummaryProgress = (enabled = true) => {
  const [progress, setProgress] = useState(DEFAULTS);
  const dbRef = useRef(null);

  useEffect(() => {
    const tenantId = getTenantId();

    if (!enabled || !tenantId) {
      setProgress(DEFAULTS);
      return;
    }

    const path = `summary_progress/${tenantId}`;
    dbRef.current = ref(database, path);

    onValue(
      dbRef.current,
      (snapshot) => {
        const data = snapshot.val();

        if (data) {
          setProgress({
            state: data.state || null,
            percentage: data.percentage || 0,
            message: data.message || "",
            isCompleted: data.state === "completed",
            isFailed: data.state === "failed",
            isListening: true,
          });
        } else {
          setProgress({ ...DEFAULTS, isListening: true });
        }
      },
      (error) => {
        console.error("[useSummaryProgress] Firebase error:", error);
      }
    );

    return () => {
      if (dbRef.current) {
        off(dbRef.current);
        dbRef.current = null;
      }
    };
  }, [enabled]);

  return progress;
};

export default useSummaryProgress;
